import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceReport {
    lookupService = new APIServiceLookUp();

    async getAllOrders(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getAllOrders`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllInvoice(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getAllInvoice`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getAllBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllTrns(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getAllTrns`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getItemWiseSummery(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getItemWiseSummery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getGSTReport(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}report/getGSTReport`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}